import React from "react";
import { Mail, Phone, Clock, AlertTriangle } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="h-8 w-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">V</span>
              </div>
              <span className="text-xl font-bold">Support & Kontakt</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Bei Fragen zum Zugang oder technischen Problemen wenden Sie sich
              an unser Support-Team:
            </p>
          </div>

          {/* Contact Information Section */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <div>
                  <span className="text-gray-300 text-sm">E-Mail Support:</span>
                  <a
                    href="mailto:support@stadtplatz.de"
                    className="block text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    support@stadtplatz.de
                  </a>
                </div>
              </li>

              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <div>
                  <span className="text-gray-300 text-sm">Telefon:</span>
                  <a
                    href="tel:+493012345678"
                    className="block text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    +49 30 123 456 78
                  </a>
                </div>
              </li>

              <li className="flex items-center space-x-3">
                <Clock className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <div>
                  <span className="text-gray-300 text-sm">Support-Zeiten:</span>
                  <span className="block text-gray-300">
                    Mo–Fr, 9:00–17:00 Uhr
                  </span>
                </div>
              </li>

              <li className="flex items-center space-x-3">
                <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0" />
                <div>
                  <span className="text-gray-300 text-sm">
                    Notfall-Support:
                  </span>
                  <a
                    href="tel:+493012345699"
                    className="block text-red-400 hover:text-red-300 transition-colors"
                  >
                    +49 30 123 456 99
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 Stadtplatz. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
